import React from 'react'
//import PropTypes from 'prop-types'
import { Email, Item, Span, Image, A, renderEmail } from 'react-html-email';
const data = {
    reference: '70001234',
    zip: '12345',
    lineItems: [
        {
            name: 'Hyper-X Plus TLSO Hyperextension Back Brace (Large Short)',
            sku: 'CYB-HYXP-LS-05',
            status: 'Denied',
            reason: 'Missing Parts/Pieces',
            imagesLink: 'https://www.braceability.com/pages/returns'
        },
        {
            name: 'Obesity Knee Pain Brace (XL)',
            sku: '03K04-XL',
            status: 'Denied',
            reason: 'Smoke Smell or Other Odor'
        },
        {
            name: 'Short Air Walking Boot (S)',
            sku: '10A14-S',
            status: 'Denied',
            reason: 'Used/Worn',
            imagesLink: 'https://www.braceability.com/pages/returns'
        }
    ],

}

const buildDeniedInfo = (reason) => {
    switch (reason) {
        case 'Used/Worn':
            return <p><strong>Used/Worn:</strong> The item was visibly used or worn, beyond just trying on the brace. This could include scuffs or dirt marks, pet hair, body dander, etc. We clean all of the products when they’re returned, and if our standard cleaning procedures cannot return the item to “like new” condition, it will be denied.</p>
        case 'Missing Parts/Pieces':
            return <p><strong>Missing Parts/Pieces:</strong>  The brace was not returned with all the necessary parts. Some products have extra pads, stockinettes or other accessories that must be returned for a full refund or exchange. If you have the missing pieces and just forgot to send them back, please contact us to let us know you’ll be sending them our way.</p>
        case 'Smoke Smell or Other Odor':
            return <p><strong>Smoke Smell or Other Odor:</strong>  Your item was returned with a noticeable odor that prevents it from being considered “like new” condition. This could be smoke smell, pet odor, body odor, etc.</p>
        default:
            break;
    }
}

const distReasons = [...new Set(data.lineItems.map(m => m.reason))]



const EmailTemplateTest = () => {
    let hasDeniedLines = false
    let statusLinkRef = `https://www.braceability.com/pages/returns?orderId=${data.reference}&postalCode=${data.zip}`

    const body = renderEmail(

        <Email align="left" title="Shipping Instructions for {curState.returnOrder.number}" style={{ marginTop: 20, border: "1px solid #efefef" }}>
            <Item align="left" >
                <Image align="left" alt="www.braceability.com" lineHeight={40} src="https://cdn.shopify.com/s/files/1/0011/7958/2517/files/logo_615x.png" width={270}  />
            </Item>
            <Item align="left">
                <Span align="left" lineHeight={15} style={{ color: '#999' }} fontSize={15}>
                    Reference Number: {data.reference}
                </Span>
            </Item>
            <Item align="left">
                <Span align="left" lineHeight={40} style={{ fontWeight: "normal", fontSize: "24px" }} fontSize={20}>Unfortunately we cannot accept your return.</Span>
            </Item>


            <Item align="center">

                <table style={{ width: '99%',marginTop:15 }}>
                    <thead>
                        <tr style={{ textAlign: 'left' }}>
                            <th >Name:</th>
                            <th >SKU:</th>
                            <th >Status:</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.lineItems.map((v, i) => {

                            return (
                                <tr style={{ marginBottom: 15, textAlign: 'left', verticalAlign: 'top', borderBottom: '1px solid lightgray' }} key={i}>
                                    <td >{v.name}</td>
                                    <td >{v.sku}</td>
                                    <td> <div style={{ marginBottom: 15 }}>
                                        <span>{v.status}<strong>{' (' + v.reason + ')'}</strong></span>
                                        {v.imagesLink && v.imagesLink !== '' ?
                                            <div> <A href={v.imagesLink} ><span><strong>(See Images)</strong></span></A></div>
                                            : <></>}
                                    </div>
                                    </td>
                                </tr>
                            );
                        }
                        )}
                    </tbody>
                </table>
            </Item>

            <Item align="left" >
                <div style={{ marginTop: 20 }}>
                    <Span align="left" style={{ fontWeight: "bold", fontSize: "20px" }} fontSize={20}>
                        Wondering why your return was denied?
                </Span>
                    <div>
                        <Span align="left" style={{ fontWeight: "normal", fontSize: "15px" }} >
                            Take a look at the reason below for a more detailed description and feel free to visit our complete return policy (link).
            </Span>
                    </div>
                </div>
            </Item>

            <Item align="left">
                <div style={{ marginTop: 5, marginLeft: 15 }}>
                    {distReasons.map((v, i) => buildDeniedInfo(v))}
                </div>
            </Item>

            <Item align="center">
                <div style={
                    {
                        maxWidth: 220,
                        borderRadius: 10,
                        backgroundColor: '#1177e9',
                        marginTop: 15,
                        padding: '10px 20px',
                        fontSize: '15px',
                        textDecoration: 'none',
                        color: '#FFFFFF',
                    }}>
                    <A href={statusLinkRef} style={{ textDecoration: 'none', color: '#FFFFFF' }}><strong>View Your Return Status.</strong></A>
                </div>
            </Item>
            {hasDeniedLines ?
                <Item align="center"  >
                    <div style={{ maxWidth: '80%' }}>
                        <p>For more information about why your return or exchange was denied, please take another look at our <A href="https://www.braceability.com/pages/returns-exchanges" style={{ fontSize: '14px', textDecoration: 'none', color: '#cddc29' }}>return policy</A>. If the item is not in new, unused, unworn condition with all it&#39;s parts and accessories, it cannot be resold. Whenever possible, we attach photos to demonstrate the reason the item was denied. Of course, we are unable to attach photos of causes like smoke smell or other odors. We hope you understand that our policy is intended to protect future customers from receiving a product in used condition. If you have any further questions, please contact <A href="mailto:support@braceability.com" style={{ fontSize: '14px', textDecoration: 'none', color: '#cddc29' }}>support@braceability.com</A>.</p>
                    </div>
                </Item>
                : <></>}

            <Item align="center"  >
                <div style={{ maxWidth: '80%', marginTop: 10 }}>
                    <p>If you have any questions, reply to this email or contact us at <A href="mailto:support@braceability.com" style={{ fontSize: '14px', textDecoration: 'none', color: '#cddc29' }}>support@braceability.com</A> or <A href="tel:866-712-7808" style={{ fontSize: '14px', textDecoration: 'none', color: '#cddc29' }}>866-712-7808</A></p>
                </div>
            </Item>
        </Email>

    )
    return (
        <div dangerouslySetInnerHTML={{ __html: body }}></div>
    )
}



export default EmailTemplateTest
